import { Box, Button, Dialog, TextField, Typography, useTheme } from "@mui/material"
import { font } from "../../styles/font"
import { useState } from "react";
import { useApplicationContext } from "../../context/ApplicationContext";
import { Entity_Label } from "../../constant/ApplicationVariables";


export default function DashboardListItemsDialog({ open, handleClose, handleConfirm, loading, setLoading }) {
  const { currentFolderData } = useApplicationContext();
  const theme = useTheme();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState(null);
  const [list, setList] = useState(["item1"]);

  const handleChange = (e, index) => {
    const newList = [...list];
    newList[index] = e.target.value;
    setList(newList);
  };

  const handleContinue = () => {
    let response = handleConfirm(list);

    if (response) {
      handleClose();
    }
  }

  return (
    <Dialog open={open} onClose={handleClose}
      sx={{ "& .MuiDialog-paper": { width: "100%", maxWidth: "400px" } }}
    >
      <Box className="flex flex-col gap-4 px-4 py-2">

        {/* header */}
        <Box className="flex items-center justify-between gap-4">
          <Typography fontSize={font.size.fs_4} color={theme.palette.text.primary}>{`List`}</Typography>
        </Box>

        {/* main container */}
        <Box className="flex flex-col gap-4">
          <Box className="flex flex-col gap-4">
            {
              list?.map((item, index) => (
                <Box className="flex items-center gap-4">

                  <TextField
                    key={index}
                    name={`item-${index}`}
                    label={`Item ${index + 1}`}
                    fullWidth
                    value={item}
                    onChange={(e) => handleChange(e, index)}
                  />
                </Box>
              ))
            }
          </Box>
          <Box className="flex flex-col gap-4">
            <Button>Add Row</Button>
          </Box>

        </Box>

        {/* footer */}
        <Box className="flex items-center justify-end gap-4">
          <Button variant="outlined" disabled={loading} onClick={handleClose}>Cancel</Button>
          <Button variant="contained" color="secondary" sx={{ color: theme.palette.text.white }} disabled={!name || loading} onClick={handleContinue}>Update</Button>
        </Box>

      </Box>
    </Dialog>
  )
}


